<template>
  <el-dialog
    class="fenceDialog common-blue-contain"
    :class="isAttendance ? 'attendanceDialog' : ''"
    top="4vh"
    :title="
      newFenceFormEdit
        ? fenceWatch
          ? $t('viewFence')
          : $t('editFence')
        : $t('newlyBuild') + fenceType
    "
    :visible.sync="newFenceDialogTableVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :append-to-body="isAppendBody"
  >
    <el-form :model="newForm">
      <div class="linetwo">
        <div class="leftColumn">
          <!-- 考勤围栏 -->
          <el-form-item :label="$t('fenceFunction')" :label-width="formLabelWidth" :required="true">
            <el-select
              v-model="isAttendance"
              :placeholder="$t('peaseSelect')"
              @change="isAttendanceChange"
              :disabled="newFenceFormEditReadonly"
              :popper-append-to-body="false"
            >
              <el-option v-for="item in AttendanceOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 普通围栏 -->
          <!-- 围栏名称/工作场所  普通围栏/考勤围栏 -->
          <el-form-item
            :label="isAttendance ? $t('workplace') : $t('nameOfFence')"
            :label-width="formLabelWidth"
            :required="true"
          >
            <el-input
              v-model="newForm.name"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('nameOfFence')"
              class="formInput"
              clearable
              :readonly="newFenceFormEditReadonly"
            ></el-input>
          </el-form-item>
          <!-- 报警距离/考勤距离 普通围栏/考勤围栏 -->

          <el-form-item
            :label="isAttendance ? $t('attendanceDistance') : $t('alarmDistanceM')"
            :label-width="formLabelWidth"
            :required="true"
            v-if="this.currEditName === 'polylineObj' || this.currEditName === 'circleObj'"
          >
            <el-input
              v-model="newForm.range"
              autocomplete="off"
              :placeholder="isAttendance ? $t('attendanceDistance') : $t('alarmDistanceM')"
              class="formInput"
              clearable
              :readonly="warmEditReadonly"
            ></el-input>
          </el-form-item>
          <!-- 中心点 普通围栏的圆围栏和线围栏-->
          <el-form-item
            :label="$t('centerPoint')"
            :label-width="formLabelWidth"
            v-if="!isAttendance && currEditName === 'circleObj'"
          >
            <el-input
              v-model="centerPoint"
              autocomplete="off"
              :placeholder="$t('centerPoint')"
              class="formInput"
              clearable
              :readonly="true"
            ></el-input>
          </el-form-item>
          <!-- 告警类型 普通围栏-->
          <el-form-item :label="$t('alarmType')" :label-width="formLabelWidth" :required="true" v-if="!isAttendance">
            <el-select
              v-model="newForm.eventWarn"
              :placeholder="$t('alarmType')"
              :disabled="newFenceFormEditReadonly"
              :popper-append-to-body="false"
            >
              <el-option :label="$t('alarmWithinRange')" value="0" :label-width="formLabelWidth"></el-option>
              <el-option :label="$t('outOfRangeAlarm')" value="1" :label-width="formLabelWidth"></el-option>
            </el-select>
          </el-form-item>
          <!-- 生效时段  普通围栏-->
          <el-form-item
            :label="$t('EffectivePeriod')"
            v-if="!isAttendance"
            :label-width="formLabelWidth"
            :required="true"
          >
            <el-time-select
              placeholder=""
              v-model="beginTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                maxTime: newForm.checkEndTime,
              }"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-time-select>
            <p class="to-date">{{ $t('TO') }}</p>
            <el-time-select
              placeholder=""
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                minTime: newForm.checkStartTime,
              }"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-time-select>
          </el-form-item>
          <!-- 生效时段  /考勤围栏 -->
          <el-form-item
            :label="$t('EffectivePeriod')"
            v-if="isAttendance"
            :required="true"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              placeholder=""
              v-model="newForm.effectStartTime"
              value-format="yyyy-MM-dd"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-date-picker>
            <p class="to-date">{{ $t('TO') }}</p>
            <el-date-picker
              placeholder=""
              v-model="newForm.effectEndTime"
              value-format="yyyy-MM-dd"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 考勤时段  考勤围栏-->
          <el-form-item
            :label="$t('attendanceDuration')"
            :label-width="formLabelWidth"
            :required="true"
            v-if="isAttendance"
          >
            <el-time-select
              placeholder=""
              v-model="beginTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                maxTime: newForm.checkEndTime,
              }"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-time-select>
            <p class="to-date">{{ $t('TO') }}</p>
            <el-time-select
              placeholder=""
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                minTime: newForm.checkStartTime,
              }"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-time-select>
          </el-form-item>

          <!-- 围栏描述 普通围栏/考勤围栏-->
          <el-form-item :label="$t('descriptionFence')" :label-width="formLabelWidth">
            <el-input
              v-model="newForm.remark"
              autocomplete="off"
              :placeholder="$t('descriptionFence')"
              class="formInput"
              type="textarea"
              :rows="3"
              maxlength="60"
              clearable
              :readonly="newFenceFormEditReadonly"
            ></el-input>
          </el-form-item>
          <!-- 打卡时间段（早）考勤围栏 -->
          <el-form-item :label="$t('clockEarly')" :label-width="formLabelWidth" :required="true" v-if="isAttendance">
            <el-time-select
              placeholder=""
              v-model="newForm.clockMorStartTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                maxTime: newForm.clockMorEndTime,
              }"
              :readonly="newFenceFormEditReadonly"
              value-format="HH:mm:ss"
              class="dateInput"
            >
            </el-time-select>
            <p class="to-date">{{ $t('TO') }}</p>
            <el-time-select
              placeholder=""
              v-model="newForm.clockMorEndTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                minTime: newForm.clockMorStartTime,
              }"
              :readonly="newFenceFormEditReadonly"
              value-format="HH:mm:ss"
              class="dateInput"
            >
            </el-time-select>
            <!-- 打卡时间段（晚）考勤围栏 -->
          </el-form-item>
          <el-form-item :label="$t('clockNight')" :label-width="formLabelWidth" :required="true" v-if="isAttendance">
            <el-time-select
              placeholder=""
              v-model="newForm.clockNigStartTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                maxTime: newForm.clockNigEndTime,
              }"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-time-select>
            <p class="to-date">{{ $t('TO') }}</p>
            <el-time-select
              placeholder=""
              v-model="newForm.clockNigEndTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                minTime: newForm.clockNigStartTime,
              }"
              :readonly="newFenceFormEditReadonly"
              class="dateInput"
            >
            </el-time-select>
          </el-form-item>
          <!-- 停留时长 考勤围栏-->
          <el-form-item :label="$t('stayTime')" :label-width="formLabelWidth" :required="true" v-if="isAttendance">
            <el-input
              v-model="newForm.stayDuration"
              :disabled="newFenceFormEditReadonly"
              :placeholder="$t('stayTime')"
              type="number"
              min="1"
              @mousewheel.native.prevent
              @DOMMouseScroll.native.prevent
            >
            </el-input>
            <div class="stay-tip">
              {{ $t('attendanceDistanceTip') }}
            </div>
          </el-form-item>

          <!-- 串联围栏 普通围栏-->
          <el-form-item :label="$t('contactOrNot')" :label-width="formLabelWidth" v-if="!isAttendance">
            <el-radio-group v-model="newForm.isContact">
              <el-radio :label="1" :disabled="newFenceFormEditReadonly">{{ $t('openN') }}</el-radio>
              <el-radio :label="0" :disabled="newFenceFormEditReadonly">{{ $t('closeN') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 是否启用 普通围栏/考勤围栏 -->
          <el-form-item :label="$t('enableOrNot')" :label-width="formLabelWidth" :required="true">
            <el-radio-group v-model="newForm.enabled">
              <el-radio :label="0" :disabled="!newFenceFormEditSave && newFenceFormEdit">{{ $t('enable') }}</el-radio>
              <el-radio :label="1" :disabled="!newFenceFormEditSave && newFenceFormEdit">{{ $t('disable') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="rightColumn">
          <el-form-item
            :label="$t('affiliatedOrganization')"
            :label-width="formRightLabelWidth"
            :class="[
              newFenceFormEditReadonly ? 'isClick' : '',
              currEditName === 'circleObj'
                ? 'circleObj'
                : currEditName === 'polylineObj'
                ? 'polylineObj'
                : currEditName === 'polygonObj'
                ? 'polygonObj'
                : '',
            ]"
          >
            <el-tree
              class="ouTree"
              ref="tree"
              :data="ouList"
              :default-checked-keys="checkedList"
              show-checkbox
              node-key="id"
              :check-strictly="true"
              @check="nodeClick"
              :props="defaultProps"
              :default-expand-all="true"
            >
            </el-tree>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer" v-if="footFlag">
      <el-button type="primary" @click="submitFormUser" v-if="!newFenceFormEdit">{{ $t('determine') }}</el-button>
      <el-button @click="cancel()" v-if="!newFenceFormEdit">{{ $t('cancel') }}</el-button>
      <!-- 编辑信息 -->
      <el-button @click="editFence()" type="primary" v-if="!newFenceFormEditSave && newFenceFormEdit">{{
        $t('modifyInformation')
      }}</el-button>
      <!-- 返回查看 -->
      <el-button @click="editFenceReturn()" v-if="newFenceFormEditSave">{{ $t('backToView') }}</el-button>
      <!-- 保存修改 -->
      <el-button @click="editFenceSave()" type="primary" v-if="newFenceFormEditSave">{{
        $t('saveInformation')
      }}</el-button>
      <!-- 删除围栏 -->
      <el-button @click="deletFence()" class="deletBtn" v-if="newFenceFormEdit && !newFenceFormEditSave">{{
        $t('deleteFence')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { geofenceSave, geofenceUpdate } from '@/api/fence'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { gcj02_to_wgs84 } from '@/util/wgs84_to_gcj02'
import { errorMessage } from '@/util/common'
export default {
  props: {
    // 底部开关
    footFlag: {
      default: true,
    },
    fenceWatch: {
      default: false,
    },
    polygonObj: {
      type: Object,
    },
    polylineObj: {
      type: Object,
    },
    circleObj: {
      type: Object,
    },
    currEditName: {
      type: String,
    },
    newFenceFormEdit: {
      type: Boolean,
    },
    newFenceDialogTableVisible: {
      type: Boolean,
    },
    newFenceFormEditReadonly: {
      type: Boolean,
    },
    newFenceForm: {
      type: Object,
    },
    formLabelWidth: {
      type: String,
    },
    ouList: {
      type: Array,
    },
    checkedList: {
      type: Array,
    },
    pointDataArr: {
      type: Array,
    },
    defaultProps: {
      type: Object,
    },
    newFenceFormEditSave: {
      type: Boolean,
    },
    initCircleCenter: {
      default: '',
    },
    isAppendBody: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    console.log(!this.newForm.enabled, 'this.newAttendanceForm.enabled')
  },

  data() {
    return {
      newForm: {},
      beginTime: '',
      endTime: '',
      //围栏类别：0普通围栏，1考勤围栏
      isAttendance: 0,
      formRightLabelWidth: '110px',
      newAttendanceForm: {
        //工作场所
        name: '',

        //生效开始、结束时间
        effectStartTime: '',
        effectEndTime: '',
        //考勤开始、结束时间
        checkStartTime: '',
        checkEndTime: '',
        //围栏描述
        remark: '',
        //打卡时间（上午）开始和结束时间
        clockMorStartTime: '',
        clockMorEndTime: '',
        //打卡时间（下午）开始和结束时间
        clockNigStartTime: '',
        clockNigEndTime: '',
        //停留时长
        stayDuration: '',
        //是否启用 0启用，1禁用
        enabled: 0,
        //考勤距离
        range: null,
      },
      AttendanceOptions: [
        {
          value: 0,
          label: this.$t('giveAlarm'),
        },
        {
          value: 1,
          label: this.$t('checkWorkAttendance'),
        },
      ],
    }
  },
  computed: {
    warmEditReadonly() {
      if (this.currEditName === 'circleObj') {
        return true
      } else {
        return this.newFenceFormEditReadonly
      }
    },
    fenceType() {
      if (this.currEditName === 'polygonObj') {
        return this.$t('faceFence')
      } else if (this.currEditName === 'polylineObj') {
        return this.$t('lineFence')
      } else if (this.currEditName === 'circleObj') {
        return this.$t('pointFence')
      } else {
        return ''
      }
    },
    centerPoint() {
      if (this.newFenceFormEdit === false) {
        // 转化坐标系
        let lnglatCenter = gcj02_to_wgs84(this.initCircleCenter.lng, this.initCircleCenter.lat)
        // let lnglatCenter = [this.initCircleCenter.lng, this.initCircleCenter.lat]
        let point = {
          lng: lnglatCenter[0],
          lat: lnglatCenter[1],
        }
        if (this.initCircleCenter.lng) {
          return `${Number(point.lat.toFixed(6))},${Number(point.lng.toFixed(6))}`
        } else {
          return ''
        }
      } else {
        let point = this.newForm.pointData[0]
        if (point) {
          return `${Number(point.lat.toFixed(6))},${Number(point.lng.toFixed(6))}`
        } else {
          return ''
        }
      }
    },
  },
  watch: {
    checkedList() {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkedList)
      })
    },
    newFenceDialogTableVisible(val) {
      if (val) {
        this.beginTime = this.newFenceForm.checkStartTime
        this.endTime = this.newFenceForm.checkEndTime
        this.newForm = this.newFenceForm
        this.isAttendance = this.newFenceForm.isAttendance
      }
    },
    //监听传进来的围栏数据的变化
    newFenceForm(val) {
      console.log(this.currEditName)
      console.log('newFenceForm', val)
    },
  },
  methods: {
    isAttendanceChange() {
      this.newForm.clockMorEndTime = this.newFenceForm.checkStartTime
      this.newForm.clockNigStartTime = this.newFenceForm.checkEndTime
      console.log(!this.isAttendance, 'this.newForm.enabled')
    },
    triggerDiaog() {
      this.$emit('triggerDiaog')
    },
    // 保存修改
    editFenceSave() {
      this.newForm.checkStartTime = this.beginTime
      this.newForm.checkEndTime = this.endTime
      this.newFenceFormEdit = true
      this.submitFormUser()
    },
    handleClose() {
      this.$emit('handleClose')
    },
    cancel() {
      this.$emit('cancel')
    },
    editFence() {
      this.$emit('editFence')
    },
    //返回查看信息页面
    editFenceReturn() {
      this.beginTime = this.newFenceForm.checkStartTime
      this.endTime = this.newFenceForm.checkEndTime
      this.$emit('editFenceReturn')
    },
    _geofenceList() {
      this.$emit('_geofenceList')
    },
    deletFence() {
      this.$emit('deletFence')
    },
    nodeClick(currentObj, treeStatus) {
      // 用于：父子节点严格互不关联时，实现单向关联。
      let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中,>=0为选中
      // 选中
      if (selected !== -1) {
        // 子节点只要被选中父节点就被选中
        this.selectedParent(currentObj)
        // 统一处理子节点为相同的勾选状态
        this.uniteChildSame(currentObj, true)
      } else {
        // 未选中 处理子节点全部未选中
        if (currentObj.children !== null) {
          this.uniteChildSame(currentObj, false)
        }
      }
    },
    uniteChildSame(treeList, isSelected) {
      this.$refs.tree.setChecked(treeList.id, isSelected)
    },
    // 统一处理父节点为选中
    selectedParent(currentObj) {
      let currentNode = this.$refs.tree.getNode(currentObj)
      if (currentNode.parent.key !== undefined) {
        this.$refs.tree.setChecked(currentNode.parent, true)
        this.selectedParent(currentNode.parent)
      }
    },
    //新增考勤围栏按钮
    submitAttFormUser() {
      //考勤时间
      //让传进来的生效时间赋值给考勤时间
      this.newForm.checkStartTime = this.beginTime
      this.newForm.checkEndTime = this.endTime
      let NodesArr = this.$refs.tree.getCheckedNodes()
      let idArr = []
      let type = ''
      if (this.currEditName === 'polygonObj') {
        type = 2
      } else if (this.currEditName === 'polylineObj') {
        type = 1
      } else if (this.currEditName === 'circleObj') {
        type = 0
      }
      for (let item of NodesArr) {
        idArr.push(item.id)
      }
      console.log(this.newForm, this.newForm, '提交')
      // 表单校验
      if (this.newForm.name === '') {
        this.$message({
          type: 'error',
          message: this.$t('workplaceCannotEmpty'),
        })
        errorCollection('电子围栏', '保存/编辑电子围栏', { status: 200, data: { state: -1, msg: '围栏名称不能为空!' } })
        return
      }
      if (this.newForm.name.length > 20) {
        this.$message({
          type: 'error',
          message: this.$t('nameCannotExceed'),
        })
        errorCollection('电子围栏', '保存/编辑电子围栏', {
          status: 200,
          data: { state: -1, msg: '名称不能超过20个字符!' },
        })
        return
      }
      if (
        this.isAttendance &&
        this.isAttendance === 1 &&
        (!this.newForm.effectStartTime || !this.newForm.effectEndTime)
      ) {
        errorMessage(this.$t('pleaseEnter') + this.$t('EffectivePeriod'))
        return
      }
      if (!this.newForm.checkEndTime || !this.newForm.checkStartTime) {
        errorMessage(this.$t('pleaseEnter') + this.$t('attendanceDuration'))
        return
      }
      if (
        this.isAttendance &&
        this.isAttendance === 1 &&
        (!this.newForm.clockMorStartTime || !this.newForm.clockMorEndTime)
      ) {
        errorMessage(this.$t('peaseSelect') + this.$t('clockEarly'))
        errorCollection('电子围栏', '保存/编辑电子围栏', {
          status: 200,
          data: { state: -1, msg: '请补充打卡时间(早)!' },
        })
        return
      }
      if (
        this.isAttendance &&
        this.isAttendance === 1 &&
        (!this.newForm.clockNigStartTime || !this.newForm.clockNigEndTime)
      ) {
        errorMessage(this.$t('peaseSelect') + this.$t('clockNight'))
        errorCollection('电子围栏', '保存/编辑电子围栏', {
          status: 200,
          data: { state: -1, msg: '请补充打卡时间(晚)!' },
        })
        return
      }
      if (this.isAttendance && this.isAttendance === 1 && !this.newForm.stayDuration) {
        errorMessage(this.$t('pleaseEnter') + this.$t('stayTime'))
        errorCollection('电子围栏', '保存/编辑电子围栏', { status: 200, data: { state: -1, msg: '请输入停留时长!' } })
        return
      }
      if (this.newFenceFormEdit === false) {
        let pointDataArrTemp = JSON.parse(JSON.stringify(this.pointDataArr))
        for (let i = 0; i < pointDataArrTemp.length; i++) {
          // 转化坐标系
          let lnglatPoint = gcj02_to_wgs84(pointDataArrTemp[i].lng, pointDataArrTemp[i].lat)
          // let lnglatPoint = [pointDataArrTemp[i].lng, pointDataArrTemp[i].lat]
          pointDataArrTemp[i] = {
            lng: lnglatPoint[0],
            lat: lnglatPoint[1],
          }
        }
        let param = {
          //所属组织
          ouIds: idArr,
          //工作场所
          name: this.newForm.name,
          //围栏类别：0普通围栏，1考勤围栏
          isAttendance: this.isAttendance,
          //生效时段
          effectStartTime: this.newForm.effectStartTime,
          effectEndTime: this.newForm.effectEndTime,
          //考勤时间
          checkStartTime: this.newForm.checkStartTime,
          checkEndTime: this.newForm.checkEndTime,
          //围栏描述
          remark: this.newForm.remark,
          //打卡时段（早）
          clockMorStartTime: this.newForm.effectStartTime + ' ' + this.newForm.clockMorStartTime + ':00',
          clockMorEndTime: this.newForm.effectStartTime + ' ' + this.newForm.clockMorEndTime + ':00',
          //打卡时段（晚）
          clockNigStartTime: this.newForm.effectStartTime + ' ' + this.newForm.clockNigStartTime + ':00',
          clockNigEndTime: this.newForm.effectStartTime + ' ' + this.newForm.clockNigEndTime + ':00',
          //停留时长
          stayDuration: this.newForm.stayDuration,
          //是否启用 0启用，1禁用
          enabled: this.newForm.enabled,
          //考勤距离
          range: this.newForm.range,
          //围栏类型0-点1-线2-面
          type: type,
          //点数据
          pointData: JSON.stringify(pointDataArrTemp),
          //告警类型
          eventWarn: 0,
        }
        geofenceSave(param).then(res => {
          if (res.state === 0) {
            this._geofenceList()
            this.$message({
              message: this.$t('AddSuccess'),
              type: 'success',
            })
            this.triggerDiaog()
          }
        })
        this[this.currEditName].editing = false
      } else {
        let param = {
          //所属组织
          ouIds: idArr,
          //工作场所
          name: this.newForm.name,
          //围栏类别：0普通围栏，1考勤围栏
          isAttendance: this.isAttendance,
          //生效时段
          effectStartTime: this.newForm.effectStartTime,
          effectEndTime: this.newForm.effectEndTime,
          //考勤时间
          checkStartTime: this.newForm.checkStartTime,
          checkEndTime: this.newForm.checkEndTime,
          //围栏描述
          remark: this.newForm.remark,
          //打卡时段（早）
          clockMorStartTime: this.newForm.effectStartTime + ' ' + this.newForm.clockMorStartTime + ':00',
          clockMorEndTime: this.newForm.effectStartTime + ' ' + this.newForm.clockMorEndTime + ':00',
          //打卡时段（晚）
          clockNigStartTime: this.newForm.effectStartTime + ' ' + this.newForm.clockNigStartTime + ':00',
          clockNigEndTime: this.newForm.effectStartTime + ' ' + this.newForm.clockNigEndTime + ':00',
          //停留时长
          stayDuration: this.newForm.stayDuration,
          //是否启用 0启用，1禁用
          enabled: this.newForm.enabled,
          //考勤距离
          range: this.newForm.range,
          //围栏类型0-点1-线2-面
          type: type,
          //点数据
          pointData: JSON.stringify(this.newForm.pointData),
          //告警类型
          eventWarn: 0,
          id: this.newForm.id,
        }
        // 画圆围栏时只截取前两个点
        if (this.newForm.type === 0) {
          param.pointData = JSON.stringify(this.newForm.pointData.slice(0, 2))
        }
        geofenceUpdate(param).then(res => {
          if (res.state === 0) {
            //更新左侧列表
            this._geofenceList()
            this.$message({
              message: this.$t('MmodificationSucceeded'),
              type: 'success',
            })
            this.triggerDiaog()
            this.editFenceReturn()
          }
        })
        this[this.currEditName].editing = false
      }
    },
    // 提交表单
    submitFormUser() {
      if (this.isAttendance) {
        this.submitAttFormUser()
        return
      }
      //让传进来的生效时间赋值给考勤时间
      this.newForm.checkStartTime = this.beginTime
      this.newForm.checkEndTime = this.endTime
      //拿右边机构数据
      let NodesArr = this.$refs.tree.getCheckedNodes()
      let idArr = []
      let type = ''
      if (this.currEditName === 'polygonObj') {
        type = 2
      } else if (this.currEditName === 'polylineObj') {
        type = 1
      } else if (this.currEditName === 'circleObj') {
        type = 0
      }
      if (type === 1) {
        if (!this.newForm.range) {
          this.$message({
            type: 'error',
            message: this.$t('alarmDistanceCannot'),
          })
          errorCollection('电子围栏', '保存/编辑电子围栏', {
            status: 200,
            data: { state: -1, msg: '报警距离不能为空!' },
          })
          return
        }
        if (this.newForm.range > 10000) {
          this.$message({
            type: 'error',
            message: this.$t('alarmDistanceCannotExceed'),
          })
          errorCollection('电子围栏', '保存/编辑电子围栏', {
            status: 200,
            data: { state: -1, msg: '报警距离不能超过10000米!' },
          })
          return
        }
        if (!/^\d+$|^\d*\.\d+$/g.test(this.newForm.range)) {
          this.$message({
            type: 'error',
            message: this.$t('distanceOnlyNumber'),
          })
          errorCollection('电子围栏', '保存/编辑电子围栏', {
            status: 200,
            data: { state: -1, msg: '报警距离只能为数字!' },
          })
          return
        }
      }
      if (type === 0) {
        if (!this.newForm.range) {
          this.$message({
            type: 'error',
            message: this.$t('alarmDistanceCannot'),
          })
          errorCollection('电子围栏', '保存/编辑电子围栏', {
            status: 200,
            data: { state: -1, msg: '报警距离不能为空!' },
          })
          return
        }
      }
      for (let item of NodesArr) {
        idArr.push(item.id)
      }
      // 表单校验
      if (!this.newForm.name) {
        this.$message({
          type: 'error',
          message: this.$t('fenceNameEmpty'),
        })
        errorCollection('电子围栏', '保存/编辑电子围栏', { status: 200, data: { state: -1, msg: '围栏名称不能为空!' } })
        return
      }
      if (this.newForm.name.length > 20) {
        this.$message({
          type: 'error',
          message: this.$t('nameCannotExceed'),
        })
        errorCollection('电子围栏', '保存/编辑电子围栏', {
          status: 200,
          data: { state: -1, msg: '名称不能超过20个字符!' },
        })
        return
      }
      if (!this.newForm.checkEndTime || !this.newForm.checkStartTime) {
        this.$message({
          type: 'error',
          message: this.$t('supplementEffectivePeriod'),
        })
        errorCollection('电子围栏', '保存/编辑电子围栏', { status: 200, data: { state: -1, msg: '请补充生效时段!' } })
        return
      }

      if (this.newFenceFormEdit === false) {
        let pointDataArrTemp = JSON.parse(JSON.stringify(this.pointDataArr))
        for (let i = 0; i < pointDataArrTemp.length; i++) {
          // 转化坐标系
          let lnglatPoint = gcj02_to_wgs84(pointDataArrTemp[i].lng, pointDataArrTemp[i].lat)
          pointDataArrTemp[i] = {
            lng: lnglatPoint[0],
            lat: lnglatPoint[1],
          }
        }
        let param = {
          //围栏类别：0普通围栏，1考勤围栏
          isAttendance: this.isAttendance,
          ouIds: idArr,
          name: this.newForm.name,
          eventWarn: this.newForm.eventWarn,
          checkStartTime: this.newForm.checkStartTime,
          checkEndTime: this.newForm.checkEndTime,
          type: type,
          isContact: this.newForm.isContact,
          pointData: JSON.stringify(pointDataArrTemp),
          remark: this.newForm.remark,
          range: this.newForm.range,
        }
        geofenceSave(param).then(res => {
          if (res.state === 0) {
            this._geofenceList()
            this.$message({
              message: this.$t('AddSuccess'),
              type: 'success',
            })
            //关闭dialog
            this.triggerDiaog()
          }
        })
        this[this.currEditName].editing = false
      } else {
        let param = {
          isAttendance: this.isAttendance,
          ouIds: idArr,
          name: this.newForm.name,
          eventWarn: this.newForm.eventWarn,
          checkStartTime: this.newForm.checkStartTime,
          checkEndTime: this.newForm.checkEndTime,
          type: this.newForm.type,
          isContact: this.newForm.isContact,
          pointData: JSON.stringify(this.newForm.pointData),
          id: this.newForm.id,
          remark: this.newForm.remark,
          enabled: this.newForm.enabled,
          range: this.newForm.range,
        }
        // 画圆围栏时只截取前两个点
        if (this.newForm.type === 0) {
          //拿到传进来的newForm
          param.pointData = JSON.stringify(this.newForm.pointData.slice(0, 2))
        }
        geofenceUpdate(param).then(res => {
          if (res.state === 0) {
            this._geofenceList()
            this.$message({
              message: this.$t('MmodificationSucceeded'),
              type: 'success',
            })
            //关闭dialog
            this.triggerDiaog()
            //恢复编辑前页面数据
            this.editFenceReturn()
          }
        })
        this[this.currEditName].editing = false
      }
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.fenceDialog
  width 100%
  >>>.el-dialog
    width 57%
    margin-top 9vh
  .el-date-editor
    width 100px!important
  .linetwo
    display flex
    overflow hidden
    flex-direction row
    color var(--search-label-color)
    .rightColumn
      width 56%
      >>>.el-form-item
        height 100%
      >>>.el-form-item__content
        height 100%!important
      .ouTree
        border: 1px solid #DCDFE6
        height 99%
        overflow auto
        background: var(--fence-tree-bg) !important;
        color: var(--aside-color) !important;
        border: var(--fence-tree-border)!important;
        border-radius: 4px;
      .circleObj
        //height 510px
      .polylineObj
        height 470px
      .polygonObj
        height 400px
   >>>.el-input
    width 314px!important
  >>>.formInput
    width 314px!important
  >>>.el-tree-node__label
    width 90%
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  >>>.el-input--suffix .el-input__inner
    background: var(--search-input-bg)
    color: var(--black-color)
    border: var(--search-input-border);
  .deletBtn
    margin-left 20px
    border: 1px solid #FF0040!important
    color: #FF0040;
  .isClick
    pointer-events: none;
  >>>.dateInput
    width 140px!important
    min-width 140px;/*no*/
    display inline-block
  .to-date
    display inline-block
    margin 0 10px
  .stay-tip
    line-height 28px
    font-style italic
    color #409eff
>>>.el-popper
  min-width 220px!important
>>>.el-dialog__body
  >>>.el-form-item
    margin-bottom 18px!important
>>>.el-form-item__label
  font-weight 600!important
  padding-right 5px!important;
// 全局css 加上以下代码，可以隐藏上下箭头
// 取消input的上下箭头
>>>input::-webkit-inner-spin-button
  -webkit-appearance: none !important;

>>>input::-webkit-outer-spin-button
  -webkit-appearance: none !important;

>>>input[type="number"]
  -moz-appearance: textfield;
.attendanceDialog
  .rightColumn
    >>>.el-form-item
      height 600px!important;
</style>
